// extracted by mini-css-extract-plugin
module.exports = {"simpleFooter":"SimpleFooter_simpleFooter__U_vKJ","center":"SimpleFooter_center__ABRbE","shieldBackground":"SimpleFooter_shieldBackground__FfEf9","lint":"SimpleFooter_lint__W_dJT"};